/**
 * AuthLoadingGate Component
 *
 * Wraps the app and shows a branded AuthTransition overlay while the
 * Auth0 SDK is initializing / restoring cached session state.
 * Once isLoading becomes false the children are rendered normally.
 */

import { useAuth0 } from "@auth0/auth0-react";
import { AuthTransition } from "./AuthTransition";

interface AuthLoadingGateProps {
  children: React.ReactNode;
}

export function AuthLoadingGate({ children }: AuthLoadingGateProps) {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <AuthTransition message="Loading..." />;
  }

  return <>{children}</>;
}
